import { Component, Injector, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppComponentBase } from '@shared/common/app-component-base';
import { AppSessionService } from '@shared/common/session/app-session.service';
import { AppRoutes } from '@app/shared/routes/app-routes';
import { KekaAccessService } from '@app/admin/keka-manager-approvals/keka-access.service';

@Component({
    standalone: false,
    selector: 'app-super-admin-topbar',
    templateUrl: './super-admin-topbar.component.html',
    styleUrls: ['./super-admin-topbar.component.scss']
})
export class SuperAdminTopbarComponent extends AppComponentBase implements OnInit, OnDestroy {
    @Input() customStyle = 'btn btn-icon btn-dropdown btn-clean mr-1 mt-0';
    @Input() isDropup = false;
    @Input() isHostSuperAdmin = false;

    isLoginForFirstTime = false;
    canViewKeka = false;
    private readonly checkLoginForTopbarSettingHandler = () => this.userQuickStartDetailsCheckSetting();

    constructor(
        private router: Router,
        public appSession: AppSessionService,
        private _kekaAccess: KekaAccessService,
        injector: Injector) {
        super(injector);
    }

    ngOnInit(): void {
        this._kekaAccess.get().subscribe(access => this.canViewKeka = access.canView);
        abp.event.on('checkLoginForTopbarSetting', this.checkLoginForTopbarSettingHandler);
        this.isLoginForFirstTime = JSON.parse(localStorage.getItem('checkLoginSuccess'));
    }

    ngOnDestroy(): void {
        abp.event.off('checkLoginForTopbarSetting', this.checkLoginForTopbarSettingHandler);
    }

    userQuickStartDetailsCheckSetting() {
        this.isLoginForFirstTime = JSON.parse(localStorage.getItem('checkLoginSuccess'));
    }

    navigate(route: string): void {
        this.router.navigate([route]);
    }

    getHostSettings() {
        this.navigate(AppRoutes.admin.hostSettings);
    }

    getLanguages() {
        this.navigate(AppRoutes.admin.languages);
    }

    getAuditLogs() {
        this.navigate(AppRoutes.admin.auditLogs);
    }

    getMaintenance() {
        this.navigate(AppRoutes.admin.maintenance);
    }

    getVisualSettings() {
        this.navigate(AppRoutes.admin.uiCustomization);
    }

    getTenants() {
        this.navigate(AppRoutes.admin.tenants);
    }

    getEditions() {
        this.navigate(AppRoutes.admin.editions);
    }

    getTrialRequests() {
        this.navigate(AppRoutes.admin.trialTenant);
    }

    getProxyLogin() {
        this.navigate(AppRoutes.admin.superAdmin);
    }

    getKeka() {
        this.router.navigate(['/admin/keka']);
    }

    getManageUsers() {
        this.navigate(AppRoutes.admin.users);
    }

    getCompanyProfile() {
        this.navigate(AppRoutes.companyProfile);
    }

    getOrganizationUnit() {
        this.navigate(AppRoutes.admin.organizationUnits);
    }

    getProductAndServiceNew() {
        this.navigate(AppRoutes.productsAndServices);
    }

    getAppCategory() {
        this.navigate(AppRoutes.appCategory);
    }

    getMasters() {
        this.navigate(AppRoutes.masters);
    }
}
